/**
 * @component StandortSelect
 * @description Dropdown-Auswahl fuer Standorte/Lager.
 * Wird nur angezeigt, wenn mehrere Standorte vorhanden sind.
 * Optionaler "Alle Standorte"-Eintrag.
 *
 * @prop {Array}    standorte    - Liste der verfuegbaren Standorte ({id, name})
 * @prop {number}   standortId   - Aktuell ausgewaehlte Standort-ID
 * @prop {function} setStandortId - Callback bei Standortwechsel
 * @prop {boolean}  [alleOption]  - Ob "Alle Standorte" angezeigt wird
 * @prop {string}   [className]   - Optionale CSS-Klassen
 * @usage Verwendet auf Operations, Schichtplanung, Warehouse, etc.
 */
export default function StandortSelect({ standorte, standortId, setStandortId, alleOption = false, className = '' }) {
  if (!standorte || standorte.length <= 1) return null;
  return (
    <select
      value={standortId || 'alle'}
      onChange={(e) => setStandortId(e.target.value === 'alle' ? 'alle' : Number(e.target.value))}
      className={`bg-surface-inset border border-line-hover rounded-lg px-3 py-2 text-xs text-content focus:outline-none focus:border-primary-500/40 ${className}`}
    >
      {alleOption && <option value="alle">Alle Standorte</option>}
      {standorte.map((s) => (
        <option key={s.id} value={s.id}>{s.name}</option>
      ))}
    </select>
  );
}
